import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useAuth } from "@/App";

export function InvoicesPageIntro() {
  const { user } = useAuth();
  const canCreate = user?.role !== "consultant";

  return (
    <div className="mb-6 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
      <p className="max-w-2xl text-sm text-muted-foreground">
        Suivi des factures, paiements, échéances et documents issus des proformas.
      </p>
      {canCreate && (
        <div className="flex flex-wrap gap-2">
          <Link
            to="/invoices/new"
            className={cn(buttonVariants({ variant: "outline", size: "sm" }))}
          >
            <Plus size={14} /> Facture directe
          </Link>
          <Link to="/proformas/new" className={cn(buttonVariants({ size: "sm" }))}>
            <Plus size={14} /> Nouvelle proforma
          </Link>
        </div>
      )}
    </div>
  );
}
